import React from 'react';
import classNames from 'classnames/bind';
import styles from './index.pcss';

const cx = classNames.bind(styles);

const TopHeader = (props): JSX.Element => {
  const { deviceType = 'mobile', howItWorks = [] } = props;
  return (
    <div className={cx('container', deviceType === 'desktop' && 'desktop-container')}>
      {howItWorks.map((list, idx) => {
        return (
          <div className={cx(deviceType === 'desktop' ? 'desktop-each-list' : 'eachList')}>
            <div className={cx('list', deviceType === 'desktop' && 'desktop-list')}>
              <span className={cx('number', deviceType === 'desktop' && 'desktop-number')}>
                {idx + 1}
              </span>
              {idx + 1 !== 4 &&
                (deviceType === 'desktop' ? (
                  <div className={cx('desktop-dashed')} />
                ) : (
                  <div className={cx('dash')}> - - - -</div>
                ))}
            </div>
            <div className={cx(deviceType === 'desktop' ? 'desktop-text' : 'text')}>{list}</div>
          </div>
        );
      })}
    </div>
  );
};

export default TopHeader;
